export default "__VITE_ASSET__42909f27__"